/** @format */

class HelpModal {
    constructor() {
        this.baseUrl = "/QmAjaxListDifference.html";
        this.ns = "tx_cpqualitymonitor_ajaxlistdifference";

        this.toggleModal();
        this.initQuarterInfo();
    }

    /* -----------------------------
     * MODAL OPEN / CLOSE
     * ----------------------------- */
    toggleModal = () => {
        document.addEventListener("click", (e) => {
            const openBtn = e.target.closest("[data-open-modal], [data-open-infomodal]");
            if (openBtn) {
                const selector =
                    openBtn.dataset.openModal || openBtn.dataset.openInfomodal;
                const modal = document.querySelector(selector);
                modal?.showModal();
                return;
            }

            const closeBtn = e.target.closest("[data-close-modal], [data-close-infomodal]");
            if (closeBtn) {
                const selector =
                    closeBtn.dataset.closeModal || closeBtn.dataset.closeInfomodal;
                const modal = document.querySelector(selector);
                modal?.close();
            }
        });

        // Klick auf Backdrop schließt Dialog
        document.querySelectorAll("dialog").forEach((dlg) => {
            dlg.addEventListener("click", (e) => {
                if (e.target === dlg) dlg.close();
            });
        });
    };

    /* -----------------------------
     * QUARTER INFO LOGIC
     * ----------------------------- */
    initQuarterInfo() {
        this.select = document.getElementById("quarter-info");
        this.tbody = document.getElementById("info-quarter-results");
        this.thPrev = document.getElementById("th-prev");
        this.thCur = document.getElementById("th-cur");

        if (!this.select || !this.tbody || !this.thPrev || !this.thCur) return;

        // Q3/2025 und Q4/2025 als Optionen
        this.select.innerHTML = `
        <option value="2025-Q3">Quartal 3/2025</option>
        <option value="2025-Q4">Quartal 4/2025</option>
    `;

        // Standard: Q4/2025 auswählen (oder Q3/2025 falls gewünscht)
        this.select.value = "2025-Q4";

        // Initial Load
        this.updateQuarterComparison(this.select.value);

        // Bei Änderung neu laden
        this.select.addEventListener("change", () => {
            this.updateQuarterComparison(this.select.value);
        });
    }

    getQuarter(date) {
        return Math.floor(date.getMonth() / 3) + 1;
    }

    parseQuarterValue(value) {
        const [yearStr, qStr] = value.split("-");
        return {year: Number(yearStr), q: Number(qStr.replace("Q", ""))};
    }

    getPreviousQuarter(year, q) {
        if (q > 1) return {year, q: q - 1};
        return {year: year - 1, q: 4};
    }

    updateQuarterComparison(value) {
        const current = this.parseQuarterValue(value);
        const prev = this.getPreviousQuarter(current.year, current.q);


        this.updateTableHead(prev, current);
        this.loadQuarterData(prev.year, prev.q);
    }

    updateTableHead(prev, cur) {
        this.thPrev.textContent = `Landesweite Pünktlichkeit Q${prev.q}-${prev.year}`;
        this.thCur.textContent = `Landesweite Pünktlichkeit Q${cur.q}-${cur.year}`;
    }

    async loadQuarterData(year, quarter) {
        this.tbody.innerHTML = `<tr><td colspan="5">Lade Daten…</td></tr>`;

        try {
            const url = new URL(this.baseUrl, window.location.origin);
            url.searchParams.set(`${this.ns}[year]`, year);
            url.searchParams.set(`${this.ns}[quarter]`, quarter);

            console.log(quarter, year, url.toString());

            const res = await fetch(url.toString(), {
                headers: {Accept: "application/json"},
            });

            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();

            this.renderTableBody(data);
        } catch (err) {
            this.tbody.innerHTML = `
        <tr>
          <td colspan="5">Fehler beim Laden der Daten</td>
        </tr>`;
            console.error(err);
        }
    }

    renderTableBody(rows) {
        if (!Array.isArray(rows) || !rows.length) {
            this.tbody.innerHTML = `
        <tr>
          <td colspan="5">Keine Daten vorhanden</td>
        </tr>`;
            return;
        }

        // stärkste Änderungen zuerst
        rows.sort((a, b) => Math.abs(b.difference) - Math.abs(a.difference));

        this.tbody.innerHTML = rows
            .map((r) => {
                return `
          <tr>
            <td>${this.escape(r.title)}</td>
            <td>${this.formatPct(r.quarter1_percent)}</td>
            <td>${this.formatPct(r.quarter2_percent)}</td>
            <td>${this.formatDiff(r.difference)}</td>
            <td>${this.escape(r.notes)}</td>
          </tr>
        `;
            })
            .join("");
    }

    /* -----------------------------
     * FORMATTERS / HELPERS
     * ----------------------------- */
    formatPct(v) {
        if (v == null) return "–";
        return `${(Number(v) * 100).toFixed(2)}%`;
    }

    formatDiff(v) {
        if (v == null) return "–";
        const pct = Number(v) * 100;
        const sign = pct > 0 ? "+" : "";
        return `${sign}${pct.toFixed(2)}%`;
    }

    escape(str = "") {
        return String(str)
            .replaceAll("&", "&amp;")
            .replaceAll("<", "&lt;")
            .replaceAll(">", "&gt;")
            .replaceAll('"', "&quot;")
            .replaceAll("'", "&#039;");
    }
}
